import React from "react";
import { Badge } from "../../../../ui/components/Badge";
import { BillEntity, BillListStatus } from "../../domain";
import {
  getBillListStatus,
  getBillListStatusLabel,
} from "../utils/billListStatus";

interface BillStatusChipProps {
  bill?: BillEntity;
  status?: BillListStatus;
}

export const BillStatusChip: React.FC<BillStatusChipProps> = ({
  bill,
  status,
}) => {
  const resolvedStatus = status ?? (bill ? getBillListStatus(bill) : "all");

  switch (resolvedStatus) {
    case "posted":
      return <Badge variant="success">{getBillListStatusLabel(resolvedStatus)}</Badge>;
    case "under_review":
      return <Badge variant="warning">{getBillListStatusLabel(resolvedStatus)}</Badge>;
    case "duplicate":
    case "rejected":
      return <Badge variant="error">{getBillListStatusLabel(resolvedStatus)}</Badge>;
    case "on_hold":
      return <Badge variant="neutral">{getBillListStatusLabel(resolvedStatus)}</Badge>;
    case "pending":
    default:
      return <Badge variant="neutral">{getBillListStatusLabel(resolvedStatus)}</Badge>;
  }
};
